import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  PageSection,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  useAnnouncements
} from "apps/school-site/features/announcements";


const RetakeExamsPage = () => {
  const {
    announcements,
    loading,
    error
  } = useAnnouncements({
    categorySlug: "egzaminy-poprawkowe",
    limit: 1
  });

  if (loading) {
    return (
      <PageSection isWidthLimited>
        <Grid>
          <GridItem
            span={12}
            md={8}
            mdOffset={2}
          >
            <Card isGlass>
              <CardBody>
                <Stack hasGutter>
                  <Skeleton width="55%" />
                  <Skeleton width="35%" />
                  <Skeleton width="100%" />
                  <Skeleton width="90%" />
                </Stack>
              </CardBody>
            </Card>
          </GridItem>
        </Grid>
      </PageSection>
    );
  }

  if (error || !announcements.length) {
    return (
      <PageSection isWidthLimited>
        <Grid>
          <GridItem
            span={12}
            md={8}
            mdOffset={2}
          >
            <Content style={{ textAlign: "center" }}>
              <h1>
                Egzaminy poprawkowe
              </h1>

              <p>
                Obecnie nie ma opublikowanych informacji
                dotyczących egzaminów poprawkowych.
              </p>
            </Content>
          </GridItem>
        </Grid>
      </PageSection>
    );
  }

  const announcement = announcements[0];

  const publishDate = announcement.publishedAt
    ? new Date(
        announcement.publishedAt
      ).toLocaleDateString(
        "pl-PL",
        {
          day: "numeric",
          month: "long",
          year: "numeric"
        }
      )
    : "";

  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content style={{ textAlign: "center" }}>
                <h1>
                  Egzaminy poprawkowe
                </h1>

                {publishDate && (
                  <p>
                    {publishDate}
                  </p>
                )}
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
            <Grid>
                <GridItem
                span={12}
                md={4}
                mdOffset={4}
                >
                <Card isGlass>
                    <CardBody>
                    <Content>
                        <div
                        dangerouslySetInnerHTML={{
                            __html: announcement.content
                        }}
                        />
                    </Content>
                    </CardBody>
                </Card>
                </GridItem>
            </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default RetakeExamsPage;